var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10 0a.5.5 0 0 1 .5.5v9a.5.5 0 1 1-1 0v-9A.5.5 0 0 1 10 0M8.5 3.5a.5.5 0 0 0-1 0v6a.5.5 0 1 0 1 0zm-4 2a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0zm-2 3a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0zM6 6a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3A.5.5 0 0 1 6 6M.5 11a.5.5 0 0 0 0 1h11a.5.5 0 1 0 0-1z",
    clipRule: "evenodd"
  })));
});
const SvgChartsmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChartsmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05Ljk5OTkxIDBDMTAuMjc2MSAwIDEwLjQ5OTkgMC4yMjM4NTggMTAuNDk5OSAwLjVWOS41QzEwLjQ5OTkgOS43NzYxNCAxMC4yNzYxIDEwIDkuOTk5OTEgMTBDOS43MjM3NyAxMCA5LjQ5OTkxIDkuNzc2MTQgOS40OTk5MSA5LjVWMC41QzkuNDk5OTEgMC4yMjM4NTggOS43MjM3NyAwIDkuOTk5OTEgMFpNOC40OTk5OCAzLjQ5OTgzQzguNDk5OTggMy4yMjM2OSA4LjI3NjEyIDIuOTk5ODMgNy45OTk5OCAyLjk5OTgzQzcuNzIzODQgMi45OTk4MyA3LjQ5OTk4IDMuMjIzNjkgNy40OTk5OCAzLjQ5OTgzVjkuNDk5ODNDNy40OTk5OCA5Ljc3NTk4IDcuNzIzODQgOS45OTk4MyA3Ljk5OTk4IDkuOTk5ODNDOC4yNzYxMiA5Ljk5OTgzIDguNDk5OTggOS43NzU5OCA4LjQ5OTk4IDkuNDk5ODNWMy40OTk4M1pNNC40OTk5OCA1LjVDNC40OTk5OCA1LjIyMzg2IDQuMjc2MTIgNSAzLjk5OTk4IDVDMy43MjM4NCA1IDMuNDk5OTggNS4yMjM4NiAzLjQ5OTk4IDUuNVY5LjVDMy40OTk5OCA5Ljc3NjE0IDMuNzIzODQgMTAgMy45OTk5OCAxMEM0LjI3NjEyIDEwIDQuNDk5OTggOS43NzYxNCA0LjQ5OTk4IDkuNVY1LjVaTTIuNDk5OTggOC41QzIuNDk5OTggOC4yMjM4NiAyLjI3NjEyIDggMS45OTk5OCA4QzEuNzIzODQgOCAxLjQ5OTk4IDguMjIzODYgMS40OTk5OCA4LjVWOS41QzEuNDk5OTggOS43NzYxNCAxLjcyMzg0IDEwIDEuOTk5OTggMTBDMi4yNzYxMiAxMCAyLjQ5OTk4IDkuNzc2MTQgMi40OTk5OCA5LjVWOC41Wk01Ljk5OTk4IDUuOTk5NzhDNi4yNzYxMiA1Ljk5OTc4IDYuNDk5OTggNi4yMjM2MyA2LjQ5OTk4IDYuNDk5NzhWOS40OTk3OEM2LjQ5OTk4IDkuNzc1OTIgNi4yNzYxMiA5Ljk5OTc4IDUuOTk5OTggOS45OTk3OEM1LjcyMzg0IDkuOTk5NzggNS40OTk5OCA5Ljc3NTkyIDUuNDk5OTggOS40OTk3OFY2LjQ5OTc4QzUuNDk5OTggNi4yMjM2MyA1LjcyMzg0IDUuOTk5NzggNS45OTk5OCA1Ljk5OTc4Wk0wLjUgMTFDMC4yMjM4NTggMTEgMCAxMS4yMjM5IDAgMTEuNUMwIDExLjc3NjIgMC4yMjM4NTggMTIgMC41IDEySDExLjVDMTEuNzc2MSAxMiAxMiAxMS43NzYyIDEyIDExLjVDMTIgMTEuMjIzOSAxMS43NzYxIDExIDExLjUgMTFIMC41WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";